<template>
  <div id="divDeleteEmails" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="myModalLabel">Delete Emails</h4>
          <button type="button" class="close" data-dismiss="modal" v-on:click="processClose()"aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <form id="delete_form" autocomplete="off">
              <label for="emails" class="form-label">&nbsp;Enter email addresses for deletion</label><br/>
              <textarea id="emails" v-model="emails"  class="form-control" size="10"></textarea>
              <div class="invalid-feedback">A maximum of 200 email addresses can be deleted at a time</div>
            </form>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light"
            data-dismiss="modal">Cancel</button>
          <button v-on:click="deleteEmails()" type="button" class="btn btn-primary"
             :disabled="emails == '' || emails == null">Delete</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  computed: {
    ...mapState({
      uiConfig: (state)=>{
        if (state.admin ) return state.admin.uiConfig;
        else return state.user.uiConfig;
      },
      adminState: (state)=>{
        return Boolean(state.admin)
      },
    }),
  },
  data: function () {
    return {
      emails: null
    }
  },
  mounted: function() {
    let that = this;
    $('#divDeleteEmails').on('shown.bs.modal', function () {
      $('#emails').focus()
    })
  },
  methods: {
    showDeleteEmails: function(options) {
      $('#divDeleteEmails').modal('show');
      this.emails = "";
    },
    async deleteEmails(){
      console.log("emails")
      let emails = this.emails.split(/[ \r\n]/).filter(i=>i!="")
      let formEl = this.$el.querySelector('#delete_form')
      $(formEl).removeClass('was-validated')
      let emailsEl = this.$el.querySelector("#emails")
      emailsEl.setCustomValidity('')
      if (emails.length > 200 ){
        emailsEl.setCustomValidity('Nope');
      }
      if (!formEl.checkValidity()){
        $(formEl).addClass('was-validated')
        return;        
      }
      console.log(emails)
      let params = {
        emails: emails,
      }
      let url = "/api/v1/email/delete"
      try {
        const response = await fetch(url, {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(params),
        });
        let result = await response.json();
        if (!response.ok){
          if (response.status == 401){
            window.location.href = "/login";
          } else {
            let msg = `${name} delete error. Status:${response.status} Error: ${result.message}`;
            this.$eventBus.$emit("showStatus",{
              msg: msg,
              title: "Unexpected Error",
              isWarning: true,
            });
          }
        } else {
          //success
          this.$eventBus.$emit("showStatus",{
            msg:`Emails successfully deleted.`,
            title: `Emails deleted`,
          });
          let props = {
            type:"Emails",
          }
          this.$store.dispatch("track",{name:"email_delete",props:props})
        }
      } catch (err){
        let msg = `${name} delete error. Error: ${err}`;
        this.$eventBus.$emit("showStatus",{
          msg: msg,
          isWarning: true,
        });
        console.log(err);
      }
      finally{
        $('#divDeleteEmails').modal('hide');
      }
    },
    processClose(){

    },
  },
}
</script>

<style scoped>
#divDeleteEmails.modal.fade {
  z-index: 100000 !important;
}
</style>